import { render, staticRenderFns } from "./DataConfirmation.vue?vue&type=template&id=57cdc520&scoped=true&"
import script from "./DataConfirmation.vue?vue&type=script&lang=js&"
export * from "./DataConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./DataConfirmation.vue?vue&type=style&index=0&id=57cdc520&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cdc520",
  null
  
)

export default component.exports